import { isPlannerToolAppType } from './config';

exports.getClientId = () => {
  const isPlannerToolType = isPlannerToolAppType();
  const clientId = localStorage.getItem('clientId');
  if (clientId) {
    return clientId;
  }
  if (isPlannerToolType && window.funlidayLib) {
    const { deviceId } = window.funlidayLib;
    localStorage.setItem('clientId', deviceId);
    return deviceId;
  }
  const newClientId = module.exports.getUUID();
  localStorage.setItem('clientId', newClientId);
  return newClientId;
};

export const getPlannerToolDeviceId = () => {
  const deviceId = localStorage.getItem('f_plannerTool_deviceId');
  if (deviceId) {
    return deviceId;
  }

  const newDeviceId = module.exports.getUUID();
  localStorage.setItem('f_plannerTool_deviceId', newDeviceId);
  return newDeviceId;
};

exports.getUUID = () => {
  let d = Date.now();
  if (
    typeof performance !== 'undefined' &&
    typeof performance.now === 'function'
  ) {
    d += performance.now(); // use high-precision timer if available
  }
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, c => {
    const r = (d + Math.random() * 16) % 16 | 0;
    d = Math.floor(d / 16);
    return (c === 'x' ? r : (r & 0x3) | 0x8).toString(16);
  });
};

const letters =
  'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
exports.getRandomString = length => {
  let string = '';
  for (let i = 0; i < length; i++) {
    const number = Math.floor(Math.random() * letters.length);
    string += letters.substring(number, number + 1);
  }
  return string;
};
